import styled from 'styled-components';
import { colors } from 'astralbeam-design';

export const BannerContainer = styled.div`
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  width: min(720px, calc(100vw - 32px));
  border-radius: 18px;
  padding: 16px 20px;
  background: linear-gradient(180deg, rgba(20,18,54,0.94), rgba(10,12,30,0.96));
  border: 1px solid rgba(150,120,255,0.3);
  box-shadow: 0 24px 80px -24px rgba(123,92,255,0.45);
  backdrop-filter: blur(12px);
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const TextContainer = styled.div`
  flex: 1 1 320px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const BannerTitle = styled.span`
  font-size: 13px;
  color: rgba(240, 242, 255, 0.95);
`;

export const BannerSub = styled.span`
  font-size: 12px;
  color: rgba(207, 214, 255, 0.6);
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  flex: 0 0 auto;
`;

export const RefuseButton = styled.button`
  padding: 9px 20px;
  border-radius: 12px;
  cursor: pointer;
  background: transparent;
  border: 1px solid rgba(255,255,255,0.28);
  color: rgba(207, 214, 255, 0.9);
  font-size: 13px;
  font-weight: 600;
  transition: color 140ms ease, border-color 140ms ease;
  &:hover { color: #fff; border-color: rgba(150,120,255,0.5); }
  &:focus-visible { outline: 2px solid rgba(150,120,255,0.7); outline-offset: 1px; }
`;

// Match the landing footer's legal links, with native button activation.
export const SettingsButton = styled.button`
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  font-size: 12px;
  color: ${colors.text.secondary};
  text-decoration: none;
  cursor: pointer;
  transition: color 140ms ease;
  &:hover { color: ${colors.text.primary}; }
  &:focus-visible { outline: 2px solid rgba(150,120,255,0.7); outline-offset: 2px; }
`;

export const AcceptButton = styled.button`
  padding: 9px 22px;
  border-radius: 12px;
  cursor: pointer;
  border: none;
  background: linear-gradient(135deg, #7b5cff, #4bc0ff);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 8px 24px -8px rgba(123,92,255,0.7);
  transition: filter 140ms ease;
  &:hover { filter: brightness(1.1); }
  &:focus-visible { outline: 2px solid rgba(150,120,255,0.9); outline-offset: 1px; }
`;

export const StyledLink = styled.a`
  color: #b1a4ff;
  text-decoration: none;
  &:hover { text-decoration: underline; }
`;
